import React, { DetailedHTMLProps, HTMLAttributes } from 'react';
import styles from './TitleGroup.module.sass';

const TitleGroup = ({
    iconBefore,
    iconAfter,
    gap,
    children
}: Props) => {

    return <div className={styles['titlegroup']}>
        { iconBefore }
        <div className={`
            ${styles['titlegroup__content']}
            ${styles['titlegroup__content__gap--'+(gap||'none')]}
        `}>
            { children }
        </div>
        { iconAfter }
    </div>
}

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>{
    iconBefore?: any
    iconAfter?: any
    gap?: 'small' | 'medium' | 'none'
}

export default TitleGroup;